"use strict";

module.exports.STATUS_MAPPING = {
  mapped: 1,
  valid: 2,
  disallowed: 3,
  disallowed_STD3_valid: 4, // eslint-disable-line camelcase
  disallowed_STD3_mapped: 5, // eslint-disable-line camelcase
  deviation: 6,
  ignored: 7
};
